document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('.section-menu-listitem a');
    const sectionmenu = document.getElementsByClassName('section-menu-collapse')[0];
    const overlay = document.getElementsByClassName('dark-overlay')[0];
    const bootstrapcollapse = new bootstrap.Collapse(sectionmenu, { toggle: false });
    const mobileviewBreakpoint = 1199;
    const navigationContainer = sectionmenu.parentElement;
    const container = navigationContainer.parentElement;
    const main = document.querySelector('main');
    const toggleButton = document.querySelector('.section-menu-toggle');
    let isScrollmenu = true;

    navigationContainer.classList.add('section-menu-container');

    if (navLinks && bootstrapcollapse) {
        navLinks.forEach((link) => {
            link.addEventListener('click', () => {
                if (window.innerWidth <= mobileviewBreakpoint) {
                    bootstrapcollapse.hide();
                }
            });
        });
    }

    if (sectionmenu && overlay) {
        sectionmenu.addEventListener('hide.bs.collapse', (event) => {
            if (event.target.classList.contains('section-menu-collapse')) {
                overlay.classList.remove('d-block');
                overlay.classList.add('d-none');
            }
        });

        sectionmenu.addEventListener('show.bs.collapse', (event) => {
            if (event.currentTarget.classList.contains('section-menu-collapse')) {
                overlay.classList.remove('d-none');
                overlay.classList.add('d-block');
            }
        });
    }

    function getSections() {
        let section = null;

        if (navLinks) {
            section = Array.from(navLinks, (link) => {
                const sectionId = link.getAttribute('href').substring(1);
                return document.getElementById(sectionId.substring(sectionId.indexOf('#') + 1));
            });
        }
        return section;
    }

    function handleScroll() {
        const scrollPosition = window.scrollY;
        const sections = getSections();

        if (sections.every((value) => value === null)) {
            isScrollmenu = false;
        }

        sections.forEach((section, index) => {
            if (section) {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.offsetHeight;
                const navLink = navLinks[index];

                if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                    navLinks.forEach((link) => link.parentElement.classList.remove('current'));
                    navLink.parentElement.classList.add('current');
                    toggleButton.textContent = navLink.textContent;
                }
            } else if (sectionmenu.querySelector('.active > a')) {
                toggleButton.textContent = sectionmenu.querySelector('.active > a').innerText;
            }
        });
    }

    function handleSmallBreakpoints() {
        if (document.body.clientWidth <= mobileviewBreakpoint) {
            const sectionsList = main.querySelectorAll('section');
            let headerSection = null;

            sectionsList.forEach((section) => {
                if (section.querySelector('.breadcrumb')) {
                    headerSection = section;
                }
            });
            headerSection.parentNode.insertBefore(navigationContainer, headerSection.nextSibling);
        } else {
            container.insertBefore(navigationContainer, container.firstChild);
        }
    }

    handleSmallBreakpoints();
    handleScroll();
    if (isScrollmenu) {
        window.addEventListener('scroll', handleScroll);
    }
    window.addEventListener('resize', handleSmallBreakpoints);
});
